<template>
  <div
    class="ctc-visual"
    :class="`ctc-visual--${size}`"
    :style="{ color, backgroundColor: tint }"
    role="img"
    :aria-label="label"
  >
    <v-icon :color="color" :size="iconSize">{{ icon }}</v-icon>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";

const ICON_SIZES = { sm: 20, md: 30, lg: 56 };

// Stand-in for product images: the POC never loads remote pictures.
export default {
  name: "CtcProductVisual",
  props: {
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "#6366F1",
    },
    size: {
      type: String,
      default: "md",
      validator: (value) => Object.keys(ICON_SIZES).includes(value),
    },
    label: {
      type: String,
      default: "Visuel produit",
    },
  },
  setup(props) {
    return {
      iconSize: computed(() => ICON_SIZES[props.size]),
      // 8-digit hex: the product color at ~12 % opacity.
      tint: computed(() => `${props.color}1F`),
    };
  },
};
</script>

<style lang="scss" scoped>
.ctc-visual {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: $rmr-radius-lg;
}

.ctc-visual--sm {
  width: 36px;
  height: 36px;
  border-radius: $rmr-radius-md;
}

.ctc-visual--md {
  width: 56px;
  height: 56px;
}

.ctc-visual--lg {
  width: 100%;
  max-width: 180px;
  aspect-ratio: 1;
  border-radius: $rmr-radius-xl;
}
</style>
